import React from "react";
import "./badge.css";

const Badge = ({
  children,
  variant,
}) => {
  return <span className={`badge badge-${variant} position-absolute d-flex align-items-center justify-content-center`}>{children}</span>;
};

export default Badge;
